var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(`${_vm.operator.name} ${_vm.operator.surname}`))]),_c('h3',[_vm._v(_vm._s(_vm.operator.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }